import React from "react";

interface AttentionChipProps {
  label: string;
  count: number;
  variant: "alert" | "warning" | "info" | "neutral";
  onClick?: () => void;
}

const variantClasses = {
  alert: "bg-secondary-90 dark:bg-secondary-30 text-secondary-30 dark:text-secondary-90",
  warning: "bg-tertiary-90 dark:bg-tertiary-30 text-tertiary-30 dark:text-tertiary-90",
  info: "bg-primary-90 dark:bg-primary-30 text-primary-30 dark:text-primary-90",
  neutral: "bg-grey-90 dark:bg-grey-30 text-grey-30 dark:text-grey-90",
};

/**
 * A single attention chip — count + label, click-through to the filtered billing page.
 * Drives the dashboard widget and the billing page's summary row.
 */
const AttentionChip: React.FC<AttentionChipProps> = ({ label, count, variant, onClick }) => {
  const base = "inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-medium";
  const interactive = onClick ? "cursor-pointer hover:underline" : "";
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className={`${base} ${variantClasses[variant]} ${interactive}`}
    >
      <span className="font-semibold">{count}</span>
      <span>{label}</span>
    </button>
  );
};

export default AttentionChip;
